import React, { useContext, useEffect, useState } from 'react';
import {
  DialogContent,
  LinearProgress,
  Button,
  Dialog,
  DialogTitle,
  IconButton,
  FormControl,
  Alert,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@mui/material';
import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import { isDesktop, isMobile, isTablet } from 'react-device-detect';
import DownloadIcon from '@mui/icons-material/Download';
import { ClearIcon } from '@mui/x-date-pickers';
import { IMerchantOrdersInvoice } from '../../../../interfaces/common/merchant-invoices';
import { AuthContext } from '../../../../contexts/user-context/user-context';
import InvoiceWaybill from '../../../common/waybill-printer/payment-task-waybill';
import { InvoiceSticker } from '../../../common/waybill-printer/payment-task-sticker';
import { ShopLocationType } from '../../../../interfaces/delivery-company/pickups';

interface InvoiceWaybillProps {
  invoice: IMerchantOrdersInvoice;
  paymentLocation: ShopLocationType | null;
  onClose?: () => void;
}

function InvoiceWaybillDownload({ invoice, paymentLocation }: InvoiceWaybillProps) {
  const { user, config } = useContext(AuthContext);
  const [mode, setMode] = useState<'sticker' | 'page'>('sticker');

  return (
    <FormControl fullWidth>
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        row
        style={{
          textAlign: 'center',
          display: 'flex',
          justifyContent: 'center',
        }}
        name="radio-buttons-group"
        onChange={(e) => setMode(e.target.value as 'sticker' | 'page')}
      >
        <FormControlLabel
          checked={mode === 'sticker'}
          value={'sticker'}
          control={<Radio />}
          label="Mini Sticker"
        />
        <FormControlLabel
          checked={mode === 'page'}
          value={'page'}
          control={<Radio />}
          label="A4"
        />
      </RadioGroup>

      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {
          <PDFDownloadLink
            document={
              mode === 'sticker' ? (
                <InvoiceSticker
                  merchantInvoice={invoice}
                  paymentLocation={paymentLocation}
                  orgId={user?.organisation?.org_id ?? 'ERROR'}
                />
              ) : (
                <InvoiceWaybill
                  merchantInvoice={invoice}
                  paymentLocation={paymentLocation}
                  orgId={user?.organisation?.org_id ?? 'ERROR'}
                />
              )
            }
            fileName={`invoice.${invoice.id}.${invoice.created_at ?? ''}.pdf`}
          >
            {({ loading } : {loading: boolean}) => {
              return loading ? (
                <Button
                  size={(isMobile && !isTablet) ? 'small' : 'medium'}
                  color="primary"
                  disabled
                >
                  Loading...
                </Button>
              ) : (
                <Button size={(isMobile && !isTablet) ? 'small' : 'medium'} color="primary">
                  <DownloadIcon fontSize="large" />
                </Button>
              );
            }}
          </PDFDownloadLink>
        }
      </div>
    </FormControl>
  );
}

export default InvoiceWaybillDownload;
